<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          unlocked the "{{ activity.source.name }}" badge
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />

      <DActivityActions
        v-if="isUserSignedIn && !isRepost"
        :activity="activity"
        @activity-removed="activityRemoved"
      />
    </div>

    <a
      class="activity-badge grid-flex grid-center grid-shrink grid-no-response no-decoration"
      :href="activity.user.url"
      :title="activity.source.name"
      @click.stop
    >
      <img
        :alt="activity.source.name"
        class="activity-badge-image space-right-2em"
        :src="activity.source.image_url"
      >

      <p class="grid grid-gutters-none activity-badge-content">
        <b>{{ activity.source.name }}</b>
        <span>View profile</span>
      </p>
    </a>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';

export default {
  mixins: [
    activityMixin,
  ],
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.activity {
  .activity-badge {
    padding: $_1-5em $_2em;
    border: $border-width-base solid getColor($grey, medium);
    border-radius: $border-radius-base;

    @include screenMoreThan(xs) {
      background-image: url('../../../../../../assets/badge-feed-bg.svg');
      background-position: right center;
      background-size: auto 100%;
      background-repeat: no-repeat;
    }

    .activity-badge-image {
      display: block;
      margin-right: $_2em;
      width: $_11em;
      height: $_11em;

      @include screenLessThan(md) {
        width: $_8em;
        height: $_8em;
      }
    }

    .activity-badge-content {
      align-self: center;
      grid-template-rows: repeat(2, min-content);

      b {
        font-size: $font-size-lg;
      }

      span {
        text-decoration: underline;
      }
    }
  }
}
</style>
